import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
    themes: {
      dark: {
        primary:    '#cc0000',
        secondary:  '#1a1a1a',
        background: '#0f0f0f',
        surface:    '#1a1a1a',
      }
    }
  }
});
